import { RecordColorEnum } from '../../../shared/enums/record-color.enum';
import { FileboxStatusEnum } from '../enums/filebox-status.enum';

/**
 * Maps the status value to a color value which is used to style the record pill in the UI
 */
export function fileboxStatusToColor(status: FileboxStatusEnum): string {
	switch (status) {
		case FileboxStatusEnum.PENDING:
			return RecordColorEnum.YELLOW;

		case FileboxStatusEnum.LEASED:
			return RecordColorEnum.BLUE;

		case FileboxStatusEnum.SYNCHRONIZED:
			return RecordColorEnum.GREEN;

		case FileboxStatusEnum.FAILED:
			return RecordColorEnum.RED;

		case FileboxStatusEnum.DEAD_LETTERED:
			return RecordColorEnum.SLATE;

		default:
			return RecordColorEnum.DEFAULT;
	}
}
